<style lang="scss">
</style>

<template>
  <div class="lookinfo">
    <Breadcrumb class="tablelist-header">
      <BreadcrumbItem>{{type!=='edit'?$t('global.common.edit',{defaultValue:'编辑'}):$t('erp.product.new_add',{defaultValue:'添加'})}}{{$t('fbb.warehouse.virtual_warehouse',{defaultValue:'虚拟仓'})}}</BreadcrumbItem>
    </Breadcrumb>
    <Alert class="padding-10">
        <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
    </Alert>
    <div class="bg-fff shadow padding-bottom-20">
      <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
      <Form :label-width="100"
            ref="form"
            :model="formData"
            class="margin-15">
        <FormItem prop="name"
                  :label="$t('global.common.name',{defaultValue:'名称'})"
                  :rules="required">
          <Input v-model="formData.name" />
        </FormItem>
        <FormItem :label="$t('global.common.project',{defaultValue:'项目'})">
          <Select v-model="formData.lineId"
                  filterable
                  :disabled="type==='edit'">
            <Option v-for="item in getNewProductList"
                    :value="item.value"
                    :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="ERPSKU">
          <Input v-model="formData.erpSku"
                 @on-blur="getProductId"
                 :disabled="type==='edit'" />
          <span class="color-error"
                v-if="type!=='edit'">{{$t('erp.virtualstore.lineskuchooseone',{defaultValue:'项目和ERPSKU必须填写一个'})}}</span>
        </FormItem>
        <FormItem prop="stockGroups"
                  :label="$t('erp.virtualstore.openwirtualware',{defaultValue:'开启虚拟仓'})"
                  :rules="required">
          <CheckboxGroup v-model="formData.stockGroups">
            <Checkbox :label="1">T1</Checkbox>
            <Checkbox :label="2">T2</Checkbox>
            <Checkbox :label="3">T3</Checkbox>
            <Checkbox :label="4">T4</Checkbox>
            <Checkbox :label="5">T5</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem prop="organizationWarehouses"
                  :label="$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})"
                  :rules="required">
          <Transfer :data="warehousesTarget"
                    :target-keys="formData.organizationWarehouses"
                    :list-style="listStyle"
                    filterable
                    :filter-method="filterMethod"
                    @on-change="handleStoreChange"></Transfer>
        </FormItem>
        <FormItem :label="$t('fbb.costmanage.explain',{defaultValue:'说明'})">
          <Input v-model="formData.description"
                 :rows="4"
                 type="textarea" />
        </FormItem>
      </Form>
      <footer class="text-center">
        <Button type="primary"
                class="width-15per"
                @click="submit">{{$t('fbb.accountmanage.next_step',{defaultValue:'下一步'})}}</Button>
        <Button class="width-15per"
                @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
      </footer>
    </div>

    <compDelayloading :loading="loading"
                      :delay="loading!==true"
                      @on-cancel="cancel"
                      @on-back="goback"></compDelayloading>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpProductErpSku } from '@/service/boss/dictionary'
import { HttpVsDetail, HttpUpdateVs, HttpSaveVs } from '@/service/boss/allot';
export default {
  components: {
    compDelayloading: () => import("@components/templates/delayloading"),
  },
  data () {
    return {
      loading: false,
      type: this.$route.params.type,
      id: this.$route.query.id,
      listStyle: {
        width: "260px",
        height: '360px',
      },
      formData: {
        name: '',
        lineId: '',
        erpSku: '',
        rules: [],
        stockGroups: [],
        organizationWarehouses: [],
        description: '',
        productId: '',
      },
      required: [{
        required: true,
        message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
      }],
      addListformData: '',
    }
  },
  mounted () {
    this.getDetail();
  },
  computed: {
    // ...mapState('boss', ['products']),
    ...mapGetters('boss', ['warehouses']),
    ...mapGetters('diction', ['getNewProductList']),
    warehousesTarget () {
      return this.warehouses.map(item => {
        return {
          key: item.id,
          label: `${item.title}(${item.code})`,
        }
      })
    },
  },
  methods: {
    cancel () {
      this.$router.push({ name: "vstorelist" })
    },

    handleStoreChange (targetKeys, direction, moveKeys, $event) {
      this.formData.organizationWarehouses = targetKeys;
    },
    handleResponse (data = {}) {
      let { name, lineId, erpSku, description, productId, stockVirtualGroupRules = [] } = data;
      let organizationWarehouses = (stockVirtualGroupRules[0] || {}).stockVirtualGroupRuleItemEntity || [],
        stockGroups = stockVirtualGroupRules.map(item => {
          return item.stockGroupId;
        });
      organizationWarehouses = organizationWarehouses.map(item => {
        return item.orgWarehouseId;
      });
      this.formData = { name, lineId, erpSku, description, productId, organizationWarehouses, stockGroups };
    },
    handleRequest () {
      const formdata = { ...this.formData };
      if (this.type === 'edit') formdata.id = this.id;
      return formdata;
    },
    goback () {
      this.loading = false;
      this.$router.push({
        name: 'vstoreChannel',
        query: { id: this.id, json: this.handleRequest() }
      })
      // 把当前数值存储到sessionStorage当中
      sessionStorage.set('addListformData', JSON.stringify(this.handleRequest()))
    },
    async getProductId (event) {
      const value = event.target.value;
      if (!value) return false;
      HttpProductErpSku({
        erpSku: value
      }).then(res => {
        this.formData.productId = res.data.id;
        this.formData.lineId = res.data.lineId;
      }, err => {
        this.formData.productId = "";
        this.formData.lineId = "";
        this.formData.erpSku = "";
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      });
    },
    async getDetail () {
      // 把当前sessionStorage拿出来
      const datas = sessionStorage.get('addListformData')
      if (datas == '') return;
      this.addListformData = JSON.parse(datas)
      this.formData = this.addListformData
    },
    async submit () {
      let valid = await this.$refs['form'].validate();
      if (!valid) return;
      this.loading = 1;
    },
    // 添加自定义搜索函数,不区分大小写
    filterMethod (data, query) {
      return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
    },
  },

}
</script>

